var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M861 309L861 337",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 861.5,
    cy: 304.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M856.987 304.19C856.987 300.283 860.288 297.117 864.358 297.117C864.943 297.117 865.511 297.184 866.056 297.308C864.742 296.48 863.187 296 861.519 296C856.814 296 853 299.806 853 304.5C853 309.194 856.814 313 861.519 313C863.814 313 865.895 312.093 867.427 310.62C866.492 311.032 865.454 311.263 864.358 311.263C860.288 311.263 856.987 308.096 856.987 304.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M870.402 303.6L870.37 301.146L868.535 302.719L866.304 302.056L867.112 304.337L865.765 306.381L868.1 306.218L869.499 308.144L870.133 305.763L872.345 304.909L870.402 303.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.ef816f4e0bad9048d363ec299bce3806.svg";
export { ForwardRef as ReactComponent };